export default __webpack_public_path__ + "static/media/march.28aeae41.jpg";